"use client";

import React from "react";
import { Instagram, Youtube, Pin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterNavConsumer({
  title
}: {
  title: string;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  return <div data-section-id="140172" className="flex flex-col gap-6">
      <h3 className="font-sans text-lg font-semibold text-primary tracking-wider uppercase">
        {title}
      </h3>
      {loading ? <div className="flex flex-col gap-4">
          <div className="h-4 w-24 bg-white/10 animate-pulse rounded-none" />
          <div className="h-4 w-32 bg-white/10 animate-pulse rounded-none" />
          <div className="h-4 w-20 bg-white/10 animate-pulse rounded-none" />
        </div> : <NavigationMenu viewport={false} className="max-w-full justify-start">
          <NavigationMenuList className="flex-col items-start gap-3 space-x-0">
            {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full">
                <NavigationMenuLink asChild>
                  <Link to={item.href || "#"} className="text-white/60 hover:text-primary transition-colors duration-300 text-sm block w-full py-1 font-sans">
                    {item.label}
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>)}
          </NavigationMenuList>
        </NavigationMenu>}
    </div>;
}
export default function AtlasRootsFooter() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Instagram,
    label: "Instagram",
    href: "https://instagram.com/milehighcavaliers"
  }, {
    icon: Pin,
    label: "Pinterest",
    href: "#"
  }, {
    icon: Youtube,
    label: "YouTube",
    href: "#"
  }];
  const legalLinks = [{
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "Terms of Service",
    href: "#"
  }, {
    label: "Health Guarantee",
    href: "#"
  }];
  return <footer id="footer" className="bg-[#262626] text-[#faf9f6] pt-32 pb-20 px-6 md:px-12 lg:px-24 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          <div className="flex flex-col gap-6 lg:pr-8">
            <Link to="/">
              <img src="https://milehighcavaliers.10web.cloud/wp-content/uploads/2026/03/MHC-logo-in-white.png" alt="Mile High Cavaliers" className="h-20 w-auto object-contain brightness-0 invert opacity-90" />
            </Link>
            <p className="text-white/60 text-sm leading-relaxed font-sans">
              Dedicated to the health and heritage of the Cavalier King Charles Spaniel, raised with love in our Colorado home.
            </p>
          </div>

          {}
          <MenuProvider menu_id="51" className="hidden" />
          <MenuProvider menu_id="50" className="hidden" />

          <div className="flex flex-col gap-6">
            <h3 className="font-sans text-lg font-semibold text-primary tracking-wider uppercase">
              Follow Us
            </h3>
            <div className="flex gap-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Button key={social.label} data-index={i} variant="ghost" size="icon" asChild className="text-white/40 hover:text-primary hover:bg-white/5 rounded-full transition-all duration-300">
                    <Link to={social.href} aria-label={social.label} newTab>
                      <Icon className="size-5" />
                    </Link>
                  </Button>;
            })}
            </div>
            <p className="text-[10px] text-white/30 uppercase tracking-[0.2em] font-sans">
              AKC & CKCSC Registered
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-6">
          <Separator className="bg-white/10" />
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[12px] uppercase tracking-widest text-white/40 font-sans">
            <p>&copy; {currentYear} Mile High Cavaliers. Designed with Love.</p>
            <ul className="flex flex-wrap justify-center gap-6">
              {legalLinks.map((link, i) => <li key={link.label} data-index={i}>
                  
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </footer>;
}